import type { HTMLProps, PropsWithChildren, ReactNode } from 'react';
import cx from 'clsx';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import { DetailValuePlaceholder, type DetailPlaceholderType } from '../../placeholders';
import styles from './details.module.css';

export function Details({ children }: PropsWithChildren): ReactNode {
  return <div className={styles.details}>{children}</div>;
}

interface DetailProps extends Omit<HTMLProps<HTMLParagraphElement>, 'value'> {
  label: string;
  detailType: DetailPlaceholderType;
  value?: ReactNode;
}

export function Detail({ label, detailType, value, ...props }: DetailProps): ReactNode {
  const { variant } = usePdfPreviewContext();

  return (
    <p className={cx(styles.detail, styles[variant])} {...props}>
      <span className={cx('body-1-bold', styles.label)}>{label}</span>
      <DetailValuePlaceholder detailType={detailType}>
        <span className="body-1">{value}</span>
      </DetailValuePlaceholder>
    </p>
  );
}
